import React from 'react'
import {
  Box,
  Button,
  Card,
  CardBody,
  Flex,
  Text
} from '@chakra-ui/react'
import { FaInfoCircle } from 'react-icons/fa'
import Header from '../../Header'
import IconWrapper from './IconWrapper'
import { ErrorStateProps } from '../types'

const ErrorState = ({ title, subtitle, error, onRetry, isRetrying }: ErrorStateProps) => (
  <Box p={{ base: 2, md: 4 }}>
    <Header title={title} subtitle={subtitle} />
    <Card bg="red.50" color="red.800" borderColor="red.300" borderWidth={1}>
      <CardBody>
        <Flex align="center" gap={2}>
          <IconWrapper icon={FaInfoCircle} />
          <Text>Error loading {title} data: {error}</Text>
        </Flex>
        <Button mt={4} colorScheme="red" onClick={onRetry} isLoading={isRetrying}>
          Retry
        </Button>
      </CardBody>
    </Card>
  </Box>
)

export default ErrorState
